import React, { memo } from 'react';

import { Container } from './styles';

const AltSeparator = (): JSX.Element => {
  return <Container />;
};

export default memo(AltSeparator);
